import { Property } from './property/property';

export class RsaService
{
    private static RSA_INSTRANCE: RsaService;
    private static key: any;
    static getInstance(property: Property): RsaService
    {
        if(this.RSA_INSTRANCE === null || this.RSA_INSTRANCE === undefined)
        {
            return new RsaService(property.getPublicKey());
        }
        return this.RSA_INSTRANCE;
    }
    encryptWithNodeRSA(plaintext: string): string 
    {
        let encryptedString: any;
        try {
             
            encryptedString = RsaService.key.encrypt(plaintext, 'base64');
    
            let encryptedStringURIEncoded = encodeURIComponent(encryptedString);
           
            return encryptedStringURIEncoded;
        }
        catch (e) {
            console.error("Exception occurred in RSA encryption: " + e.message);
            console.error(e.stack);
            return "";
        }
    }
    constructor(publicKey: string)
    {
       var options1 = {
           environment: 'node',
           encryptionScheme: {
               scheme: 'pkcs1'
           }
       };//eslint-disable-next-line
       const NodeRSA = require('node-rsa');
       RsaService.key = new NodeRSA(publicKey);
       RsaService.key.setOptions(options1);
    }
}  




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/utils/rsaservice.tsx